import { render, staticRenderFns } from "./MDTDDocument.vue?vue&type=template&id=ec3ceb2e&scoped=true"
import script from "./MDTDDocument.vue?vue&type=script&lang=js"
export * from "./MDTDDocument.vue?vue&type=script&lang=js"
import style0 from "./MDTDDocument.vue?vue&type=style&index=0&id=ec3ceb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3ceb2e",
  null
  
)

export default component.exports